import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { isImageOrImageFillShape } from '@src/slide/domain/ui-model/elements/element-judge';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

@Feature()
export class OCRPictureFeature extends BaseToolbarFeature {
    public id = config.id;
    public constructor() {
        super();
    }

    public showOcrRightBar() {
        const model = this.getFirstPictureModel();
        if (!model) {
            return;
        }
        const ocrService = (AppServiceProvider.getInstance().getAppServices() as IEditorAppServices)
            .editableServiceLayer?.ocrService;
        ocrService?.promise()
            .then(ocrService => ocrService.showOcrRightBar(model));
    }

    public shouldOCRDisabled() {
        const model = this.getSelectModel() as IElementBaseModel;
        return !isImageOrImageFillShape(model) || ENV.IS_LOCAL_EDIT;
    }

    private getFirstPictureModel(): IPictureModel {
        const model = this.getSelectionService().getSelectedModel();
        const selectedModels = getAllChildModels(model as IElementBaseModel);
        return selectedModels.find(isImageOrImageFillShape) as IPictureModel;
    }
}
